import { render } from "./FilterImages.vue?vue&type=template&id=2e3a919b&ts=true"
import script from "./FilterImages.vue?vue&type=script&lang=ts"
export * from "./FilterImages.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\Pablo\\Documents\\Programacion\\Playas\\beachguard_v3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__